// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"c599fb67","453":"ee246fe8","977":"cb0d0368"}[chunkId] + ".chunk.js";
};